var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaggageCarryon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3C8 1.89543 8.89543 1 10 1H14C15.1046 1 16 1.89543 16 3V12H17C18.1046 12 19 12.8954 19 14V20C19 21.1046 18.1046 22 17 22C17 22.5523 16.5523 23 16 23C15.4477 23 15 22.5523 15 22H9C9 22.5523 8.55228 23 8 23C7.44772 23 7 22.5523 7 22C5.89543 22 5 21.1046 5 20V14C5 12.8954 5.89543 12 7 12H8V3ZM14 3V12H10V3L14 3ZM8 17H16V16H8V17Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaggageCarryon);
export default __webpack_public_path__ + "static/media/baggage_carryon.59aa0c7c40c8f8f356fe28bc31598fa5.svg";
export { ForwardRef as ReactComponent };